import { Tooltip, Typography } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { ErrorMessage } from 'formik';
import { Flex } from 'rebass';
import { QuestionCircleOutlined } from '@ant-design/icons';
import Error from '../error';
import { Control } from './controls';
import Title from '../title';
import styled from 'styled-components';

const StyledTitle = styled(Title)`
  font-size:12px;
  font-weight:700;
  
`;

export function FormControl({ name, type, width, tooltip, settings = {}, label, ...props }) {
  return (
    <Flex flexDirection="column" p={2} pl={0} width={width} {...props}>
      {label && (
        <StyledTitle className={'form-control-'+type}>
          {label}
          {tooltip && (
            <Tooltip placement="bottom" title={tooltip}>
              <QuestionCircleOutlined style={{ fontSize: '16px', marginLeft: '10px' }} />
            </Tooltip>
          )}
        </StyledTitle>
      )}
      <Control name={name} type={type} settings={settings} {...props} />
      {settings?.hint && <Typography.Text type="secondary">{settings?.hint}</Typography.Text>}
      <ErrorMessage name={name} component={Error} />
    </Flex>
  );
}

FormControl.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  width: PropTypes.any,
  type: PropTypes.string,
  value: PropTypes.any,
  dependant: PropTypes.bool,
  placeholder: PropTypes.string,
  tooltip: PropTypes.string,
  settings: PropTypes.object,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  children: PropTypes.node,
};
